import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { pipe, tap } from 'rxjs';

import { Container } from './models';

type ContainerSelectorState = {
    selectedContainers: Container[];
    availableContainers: Container[];
    totalContainers: number;
};

const initialState: ContainerSelectorState = {
    selectedContainers: [],
    availableContainers: [],
    totalContainers: 0,
};

function filterContainers(containers: Container[], selectedContainers: Container[]): Container[] {
    // if a container has been selected, remove from selection list to prevent container duplication
    return containers.filter((c) => !selectedContainers.some((selected) => selected.number === c.number));
}

function sortContainers(containers: Container[]): Container[] {
    return [...containers].sort((a, b) => a.number - b.number);
}

export const ContainerSelectorStore = signalStore(
    withState(initialState),
    withMethods((store) => ({
        hasContainerBeenSelected(container: Container) {
            return store.selectedContainers().find(({ number }) => number === container.number);
        },
        addSelectedContainers(container: Container) {
            const availableContainers = filterContainers(store.availableContainers(), [container]);
            const selectedContainers = sortContainers([...store.selectedContainers(), container]);

            patchState(store, () => ({
                selectedContainers,
                availableContainers,
            }));
        },
        removeSelectedContainer(container: Container) {
            const availableContainers = sortContainers([...store.availableContainers(), container]);
            patchState(store, (state) => ({
                selectedContainers: state.selectedContainers.filter(
                    ({ number }) => number !== container.number,
                ),
                availableContainers,
            }));
        },
        setAvailableContainers: rxMethod<Container[]>(
            pipe(
                tap((containers) => {
                    const availableContainers = filterContainers(containers, store.selectedContainers());
                    const totalContainers = containers.length;
                    patchState(store, () => ({
                        availableContainers,
                        totalContainers,
                    }));
                }),
            ),
        ),
    })),
);
